import React, { useEffect, useState } from "react";
import { adminApi } from "@/lib/adminApi";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { toast } from "sonner";

// Vehicle RC checks needing a human: holder-name mismatches (carrier continues meanwhile) and manual reviews.
export const RcReviews = () => {
  const [rows, setRows] = useState([]);
  const load = () => adminApi.get("/rc-reviews").then((r) => setRows(r.data)).catch(() => setRows([]));
  useEffect(() => { load(); }, []);
  const decide = async (id, approve) => {
    try { await adminApi.post(`/rc-reviews/${id}/decide`, { approve }); toast.success(approve ? "Approved" : "Rejected"); load(); }
    catch (e) { toast.error(e?.response?.data?.detail || "Failed"); }
  };
  if (!rows.length) return null;
  return (
    <div className="mb-6" data-testid="rc-reviews">
      <h2 className="font-display text-lg font-bold mb-2">Vehicle RC reviews</h2>
      <div className="rounded-2xl border border-slate-200 bg-white divide-y divide-slate-100">
        {rows.map((r) => (
          <div key={r.id} className="p-4 flex items-center gap-3 flex-wrap" data-testid={`rc-review-${r.id}`}>
            <Badge className={r.reason === "name_mismatch" ? "bg-amber-100 text-amber-800" : "bg-sky-100 text-sky-800"}>
              {r.reason === "name_mismatch" ? "RC name mismatch — review" : "RC manual review"}
            </Badge>
            <div className="text-sm flex-1 min-w-[220px]">
              <span className="font-semibold">{r.user?.name}</span> <span className="text-slate-400 text-xs">{r.user?.phone}</span>
              <div className="text-xs text-slate-600 mt-0.5">RC <span className="font-mono">{r.reg_no}</span>{r.rc_owner_name ? <> · RC holder: <b>{r.rc_owner_name}</b></> : null} · Name on account: <b>{r.user_name || "—"}</b></div>
            </div>
            <Button size="sm" onClick={() => decide(r.id, true)} data-testid={`rc-approve-${r.id}`}>{r.reason === "name_mismatch" ? "OK — keep" : "Approve RC"}</Button>
            <Button size="sm" variant="outline" className="text-rose-700" onClick={() => decide(r.id, false)} data-testid={`rc-reject-${r.id}`}>Reject</Button>
          </div>
        ))}
      </div>
    </div>
  );
};

export default RcReviews;
